import React from "react";
import PropTypes from "prop-types";
import { useSolrContext } from "@e-fork/solr";
import useStickyFilterVanish from "@default/hooks/use-sticky-filter-vanish";
import NoResults from "../components/system/no-results";
import Loading from "../components/system/loading";
import Error from "../components/system/error";
import Pagination from "../components/system/pagination";
import EndlessScroll from "../components/system/endless-scroll";
import TeaserBase from "@default/teasers/teaser-base";
import newsSchemaMapper from "@default/teasers/news/news-schema-mapper";
import FiltersControlFacet from "../components/filters/filters-control-facet";
import { getGroupId } from "../components/filters/facet-types/scroll-to-facet";
import { groupBy } from "lodash";
import { FormattedMessage } from "react-intl";

const OverviewNews = ({ content }) => {
  const { items, error, config } = useSolrContext();
  const { sentinelRef, filterWrapperRef } = useStickyFilterVanish();

  const yearFacet = config.facets.find((f) => f?.id === "news_published_year");

  const itemsByYear = groupBy(items, (item) =>
    new Date(+item.published_at * 1000).getFullYear()
  );
  const yearGroups = Object.entries(itemsByYear).sort(([a], [b]) => b - a);

  return (
    <section
      className={`paragraph paragraph-overview overview-solr news-overview type-${content.fieldNewsType}`}
    >
      <div className="container">
        <div ref={sentinelRef} />
        <div
          ref={filterWrapperRef}
          className="row sticky-wrapper filter-wrapper"
        >
          <div className="col-12">
            <div className="d-flex gap-xs justify-content-start">
              {yearFacet && (
                <FiltersControlFacet
                  id={yearFacet.id}
                  label={yearFacet.label}
                  type={yearFacet.type}
                />
              )}
            </div>
          </div>
        </div>
        {!error &&
          yearGroups.map(([year, yearItems]) => (
            <div className="year-wrapper row" key={year} id={getGroupId(year)}>
              <div className="col-12">
                <h2 className="headline-xl">
                  <FormattedMessage
                    id={`overview.${content.fieldNewsType}.title`}
                    values={{ year }}
                  />
                </h2>
              </div>
              {yearItems.map((item) => (
                <div key={item.id} className="col-12 col-lg-4">
                  <TeaserBase item={newsSchemaMapper(item)} />
                </div>
              ))}
            </div>
          ))}
        <div className="row">
          <div className="col-12">
            <NoResults />
            <Loading />
            <Error />
          </div>

          {config.pageMode === "pager" && <Pagination />}
          {config.pageMode === "endless" && <EndlessScroll />}
        </div>
      </div>
    </section>
  );
};

OverviewNews.propTypes = {};

export default OverviewNews;
